module.exports = __webpack_public_path__ + "static/media/monopoly-commercial.ddf14b3d.mp4";